export class Route {
  id: number;
  name: string;
  created_at?: string;

  constructor(data) {
    Object.assign(this, data);
  }

}
